export default {
  init() {
    // JavaScript to be fired on the home page
    $('.module-hero__content .down-arrow').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('.module-goals').offset().top,
      }, 1200);
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js